var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}],attrs:{"subheader":"","dense":""}},[_c('v-subheader',{staticClass:"md-4"},[_vm._v(" Chat ")]),_vm._l((_vm.GET_MESSAGES),function(msg,index){return _c('MessageItem',{key:index,attrs:{"message":msg}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }